export default __webpack_public_path__ + "static/media/icons-phone-navigation-black.67d6b82b.svg";